import React from 'react'

import { Box } from '@hub/box'
import { HubIcon } from '@hub/icon'
import { LinkBox, LinkOverlay } from '@hub/link'
import { Stack } from '@hub/stack'
import { Text } from '@hub/text'

type InfoPageTileProps = {
  title: string
  link: string
  description: string
  Icon?: HubIcon
}

const InfoPageTile: React.FC<React.PropsWithChildren<InfoPageTileProps>> = ({
  link,
  title,
  description,
  Icon,
}) => {
  return (
    <LinkBox>
      <Box role="group">
        <LinkOverlay href={link}>
          <Stack
            gap={'spacing-sm'}
            sx={{
              px: 'spacing-xl',
              py: 'spacing-lg',
            }}
          >
            {Icon && <Icon boxSize={'size-icon-md'} />}
            <Text tone={'strong'} fontSize={'font-lg'}>
              {title}
            </Text>
            <Box color={'quartz'} _groupHover={{ color: 'licorice' }}>
              <Text fontSize={'font-md'}>{description}</Text>
            </Box>
          </Stack>
        </LinkOverlay>
      </Box>
    </LinkBox>
  )
}

export default InfoPageTile
